var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useDynamicBoolean } from '@doordash/component-dynamic-values';
import { PORTAL_ROUTE_PREFIX } from '../constants/values';
import AdminPageSidebar from './admin_page_sidebar';
import AdminMembersContainer from './admin_members_container';
import AdminBilling from './Billing/admin_billing';
import MealBudgetsContainer from './MealBudgets/MealBudgetsContainer';
import OrderHistory from './BillingHistory/order_history';
import GroupsPageContainer from './Groups/groups_page_container';
import DashPassContainer from './DashPass/DashPassContainer';
import OnboardingContainer from './SelfServe/Onboarding/Onboarding';
import { getSelectedTeamAccount, getSelectedTeamAccountContent, shouldRenderMultiPortalSelector, } from '../selectors/uiSelector';
import { getTeamId, getIsAdmin, getTeamName, getCurrentTeamMember, } from '../selectors/portal_selector';
import { useGetConsumerInfo } from './DynamicValues/hook';
import { selectTeamAccount } from './Ui/ui_slice';
import { AdminPagePortalWrapper, AdminPageContentContainer, } from './AdminPage/AdminPageStyles';
import { TeamAccountSelector } from './AdminPage/TeamAccountSelector';
import { DYNAMIC_VALUES_NAME } from './DynamicValues';
import PendoUtil from '../bootstrap/pendo';
import { TeamAccountConfigurationProvider } from './TeamAccountPlanDetails/TeamAccountConfigurationContext';
import { BaseContainer } from './Styles/Containers';
export var AdminPageContainer = function (props) {
    var dispatch = useDispatch();
    var consumerId = useGetConsumerInfo().consumerId;
    var teamId = useSelector(getTeamId) || '';
    var teamName = useSelector(getTeamName) || '';
    var isAdmin = useSelector(getIsAdmin);
    var selectedTeamAccount = useSelector(getSelectedTeamAccount);
    var selectedTeamAccountContent = useSelector(getSelectedTeamAccountContent);
    var currentTeamMember = useSelector(getCurrentTeamMember);
    var shouldRenderMultiPortalDropDown = useSelector(shouldRenderMultiPortalSelector);
    var isPendoEnabled = useDynamicBoolean(DYNAMIC_VALUES_NAME.ddfwPendoEnabled, {
        consumerId: consumerId,
        teamId: teamId,
    });
    var initializePendo = React.useCallback(function () {
        if (isPendoEnabled && isAdmin && selectedTeamAccountContent) {
            PendoUtil.initializePendo(consumerId, currentTeamMember, selectedTeamAccountContent, teamId, teamName);
        }
    }, [
        selectedTeamAccountContent,
        consumerId,
        teamId,
        teamName,
        isAdmin,
        isPendoEnabled,
        currentTeamMember,
    ]);
    React.useEffect(function () {
        initializePendo();
    }, [initializePendo]);
    React.useEffect(function () {
        var _a, _b, _c, _d;
        // we will sync between the Ui Reducer's `selectedTeamAccount` and the team account id in URL
        // case 1: user make selection, so ui state changed; we push path
        // case 2: user enter the route directly, sync with ui selected state
        var teamAccountIdFromUrl = (_c = (_b = (_a = props.match) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.teamAccountId) !== null && _c !== void 0 ? _c : '';
        var currentUrl = (_d = props.match) === null || _d === void 0 ? void 0 : _d.url;
        if (selectedTeamAccount === teamAccountIdFromUrl) {
            return;
        }
        if (!Boolean(selectedTeamAccount) && Boolean(teamAccountIdFromUrl)) {
            // this is entering directly.
            // we should sync the selector to be whatever currentTeamAccountId is
            dispatch(selectTeamAccount(teamAccountIdFromUrl));
            return;
        }
        if (Boolean(teamAccountIdFromUrl) &&
            Boolean(selectedTeamAccount) &&
            selectedTeamAccount !== teamAccountIdFromUrl &&
            currentUrl.includes(teamAccountIdFromUrl)) {
            var newUrl = PORTAL_ROUTE_PREFIX + "/admin/" + selectedTeamAccount + "/members";
            props.history.push(newUrl);
        }
    }, [selectedTeamAccount]);
    return (React.createElement(BaseContainer, null,
        React.createElement(AdminPagePortalWrapper, null,
            React.createElement(TeamAccountSelector, { shouldRender: shouldRenderMultiPortalDropDown }),
            React.createElement(AdminPageContentContainer, { shouldRenderMultiPortalDropDown: shouldRenderMultiPortalDropDown },
                React.createElement(TeamAccountConfigurationProvider, { teamAccountId: props.match.params.teamAccountId },
                    React.createElement(AdminPageSidebar, { teamAccountId: props.match.params.teamAccountId }),
                    React.createElement(Switch, null,
                        React.createElement(Route, { path: PORTAL_ROUTE_PREFIX + "/admin/:teamAccountId/onboarding", render: function () {
                                return React.createElement(OnboardingContainer, null);
                            } }),
                        React.createElement(Route, { path: PORTAL_ROUTE_PREFIX + "/admin/:teamAccountId/members/:page?", render: function () {
                                return React.createElement(AdminMembersContainer, __assign({}, props));
                            } }),
                        React.createElement(Route, { path: PORTAL_ROUTE_PREFIX + "/admin/:teamAccountId/groups", render: function () {
                                return React.createElement(GroupsPageContainer, null);
                            } }),
                        React.createElement(Route, { path: PORTAL_ROUTE_PREFIX + "/admin/:teamAccountId/billing", render: function () {
                                return React.createElement(AdminBilling, null);
                            } }),
                        React.createElement(Route, { path: PORTAL_ROUTE_PREFIX + "/admin/:teamAccountId/budgets", render: function () {
                                return React.createElement(MealBudgetsContainer, null);
                            } }),
                        React.createElement(Route, { path: PORTAL_ROUTE_PREFIX + "/admin/:teamAccountId/order-history", render: function () {
                                return (React.createElement(OrderHistory, __assign({ teamAccountId: props.match.params.teamAccountId }, props)));
                            } }),
                        React.createElement(Route, { path: PORTAL_ROUTE_PREFIX + "/admin/:teamAccountId/dashpass", render: function () {
                                return React.createElement(DashPassContainer, null);
                            } })))))));
};
export default withRouter(AdminPageContainer);
